import { Collapse, Divider } from "antd";
import {
	ActionButtonComponent,
	AddDocCategoriesContainer,
	AddItemsContainer,
} from "./style";
import { DocCategoryItems } from "./constants";
import { UpOutlined } from "@ant-design/icons";
import MainButtonComponent from "../../components/MainButtonComponent";
import { useDocCategoryContext } from "../../context/DocumentCategoryContext/DocumentCategoryContext";

const AddDocumentCategory = () => {
	const { addDocCategory, operationStatus } = useDocCategoryContext();

	return (
		<AddDocCategoriesContainer>
			<AddItemsContainer>
				<h3>Yeni Kategori Ekleme</h3>
				<Divider />
				<Collapse
					items={DocCategoryItems}
					expandIconPosition="end"
					bordered={false}
					expandIcon={({ isActive }) => (
						<UpOutlined rotate={isActive ? 0 : -180} />
					)}
					defaultActiveKey={["1", "2"]}
				/>
				<ActionButtonComponent>
					<MainButtonComponent onClick={addDocCategory} loading={operationStatus.type === "loading" && operationStatus.operation === "add"}>
						Kategoriyi Ekle
					</MainButtonComponent>
				</ActionButtonComponent>
			</AddItemsContainer>
		</AddDocCategoriesContainer>
	);
};

export default AddDocumentCategory;
